import { ListGroup as ReactstrapListGroup, ListGroupItem } from 'reactstrap';

const ListGroup = ReactstrapListGroup;

ListGroup.Item = ListGroupItem;

export default ListGroup;
